import 'rc-time-picker/assets/index.css';
import React from "react";
import Alert from "react-bootstrap/lib/Alert";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import {API_URL, minutesPerSlot} from "../../constants";
import {connect} from "react-redux";
import {updateCalendarSession} from "../../redux/actions";

class CalendarSessionModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formData: {
                timeStart: moment.utc(this.props.calendarSession.start_time, "hh:mm:ss"),
                timeEnd: moment.utc(this.props.calendarSession.end_time, "hh:mm:ss"),
            },
            alertShow: false,
            alertMessage: '',
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleDateChange(fieldName, value) {
        const {formData} = {...this.state};
        formData[fieldName] = value;

        this.setState(formData);
    }

    handleSave() {
        const {formData} = this.state;
        const {calendarSession} = this.props;
        const body = {
            room_id: calendarSession.room.id,
            date: calendarSession.date,
            start_time: formData.timeStart ? formData.timeStart.format("HH:mm:ss"): null,
            end_time: formData.timeEnd ? formData.timeEnd.format("HH:mm:ss") : null
        };

        fetch(API_URL + '/calendar/' + calendarSession.id, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + this.props.user.api_token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(body),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);    // Will go to .catch
                return response.json();
            })
            .then((result) => {
                /* Update calendar session */
                this.props.updateCalendarSession(calendarSession.id, result.data);

                /* Close modal window */
                this.props.handleClose();
            })
            .catch((error) => {
                this.showAlert(error.toString());
            })
    }

    showAlert(message) {
        this.setState((state, props) => ({
            alertShow: true,
            alertMessage: message
        }));
    }

    render() {
        const {show} = this.props;
        const {formData} = this.state;

        let alert;
        if (this.state.alertShow) {
            alert = <React.Fragment><br/><br/><Alert bsStyle="danger">{this.state.alertMessage}</Alert></React.Fragment>
        }

        return (
            <Modal show={show} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Calendar Session</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>Time Start (hh:mm)*</span>
                    <TimePicker style={{width: 100}}
                                defaultValue={formData.timeStart}
                                showSecond={false}
                                minuteStep={minutesPerSlot}
                                onChange={(value) => this.handleDateChange("timeStart", value)}/>
                    <span>Time End (hh:mm)*</span>
                    <TimePicker style={{width: 100}}
                                defaultValue={formData.timeEnd}
                                showSecond={false}
                                minuteStep={5}
                                onChange={(value) => this.handleDateChange("timeEnd", value)}/>
                    <br/>
                    <br/>
                    <span>(*) Mandatory fields</span>
                    {alert}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.handleClose}>Close</Button>
                    <Button bsStyle="primary" onClick={this.handleSave}>Save changes</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default connect(
    null,
    {updateCalendarSession}
)(CalendarSessionModal);
